import { useState } from "react";
import { motion } from "framer-motion";
import PageWrapper from "../../components/layout/PageWrapper";
import { galleryCategories, allGalleryImages } from "../../data/galleryData";

export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState("all");

  const tabs = [{ id: "all", label: "All" }, ...galleryCategories];

  const visibleImages =
    activeCategory === "all"
      ? allGalleryImages
      : galleryCategories.find((c) => c.id === activeCategory)?.images || [];

  const activeCategoryDescription =
    activeCategory === "all"
      ? "Browse a curated mix of our events, environments, and brand moments."
      : galleryCategories.find((c) => c.id === activeCategory)?.description ?? "";

  return (
    <PageWrapper>
      <section className="pt-8 pb-12 md:pt-12 md:pb-16 border-b border-gold-muted/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-3xl md:text-4xl font-semibold text-aura-text">
            Gallery
          </h1>
          <p className="mt-4 font-sans text-sm md:text-base text-aura-text max-w-2xl mx-auto">
            A collection of visuals from our events, spaces, and brand experiences.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-aura-bg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category tabs */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-8 md:mb-10">
            {tabs.map((tab) => {
              const isActive = activeCategory === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveCategory(tab.id)}
                  className={`px-4 md:px-5 py-2 rounded-full border text-sm font-sans font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-gold-primary text-aura-text border-gold-primary shadow-sm"
                      : "bg-transparent text-aura-text border-gold-muted/40 hover:border-gold-primary/70 hover:bg-gold-light/20"
                  }`}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>

          {activeCategoryDescription && (
            <p className="font-sans text-sm md:text-base text-aura-text/90 text-center max-w-3xl mx-auto mb-10">
              {activeCategoryDescription}
            </p>
          )}

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {visibleImages.map((image, i) => (
              <motion.div
                key={`${image.src}-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                className="relative overflow-hidden rounded-sm border border-gold-muted/20 bg-gold-light/10"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}

